const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 22 22"
      className="stroke-current"
    >
      <g
        id="Group_9624"
        data-name="Group 9624"
        transform="translate(-596.5 -228.5)"
      >
        <line
          id="Line_192"
          data-name="Line 192"
          y2={22}
          transform="translate(607.5 228.5)"
          fill="none"
          strokeWidth={2}
        />
        <line
          id="Line_193"
          data-name="Line 193"
          y2={22}
          transform="translate(618.5 239.5) rotate(90)"
          fill="none"
          strokeWidth={2}
        />
      </g>
    </svg>
  )
}

export default PlusIcon
